export default __webpack_public_path__ + "static/media/AQSPEC_Login.5d2d8157.png";